import React from 'react';
import classnames from 'classnames';

import styles from './Button.module.scss';

import Icon from 'utils/components/icon';

export type ButtonPropsTheme =
  | 'contained-apply-dangerous'
  | 'contained-apply'
  | 'contained-discard'
  | 'outlined-apply-dangerous'
  | 'outlined-discard'
  | 'contained-info';

interface ButtonProps {
  theme?: ButtonPropsTheme;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface DeleteButtonProps {
  variant: 'primary' | 'secondary';
  disabled?: boolean;
  showIcon?: boolean;
  onClick: () => void;
}

const Button: React.FC<ButtonProps> = ({
  theme = 'primary-apply',
  disabled,
  className,
  style,
  icon,
  onClick,
  children
}) => {
  const buttonClassNames = classnames(styles.button, styles[theme], className);
  return (
    <button disabled={disabled} className={buttonClassNames} style={style} onClick={onClick}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
    </button>
  );
};

const DeleteButton: React.FC<DeleteButtonProps> = ({
  showIcon = true,
  variant,
  disabled,
  onClick,
  children
}) => {
  return (
    <Button
      theme={variant === 'primary' ? 'contained-apply-dangerous' : 'outlined-discard'}
      disabled={disabled}
      onClick={onClick}
      icon={showIcon && <Icon name="garbage" />}
    >
      {children}
    </Button>
  );
};

export { Button, DeleteButton };
